import { useLocation, Link } from "react-router-dom";
import toggleNavBar from "../utils/toggle-nav-bar.js";
import "./Navigation.sass";

function HighlightSelected() {
  const location = useLocation();

  const navItems = [
    {
      name: "Ocorrências",
      img: "contract",
      id: "incident-element",
      redirectTo: "/incident",
      routes: ["/incident"],
      adminOnly: false,
    },
    {
      name: "Administração",
      img: "admin",
      id: "admin-element",
      redirectTo: "/admin",
      routes: ["/admin"],
      adminOnly: true,
    },
  ];

  const isAdmin = localStorage.getItem("isAdmin") === "true";

  const filteredNavItems = isAdmin
    ? navItems
    : navItems.filter((navItem) => !navItem.adminOnly);

  return (
    <div id="nav-bar" className="expanded">
      <div className="nav-item" id="toggle-nav-button" onClick={toggleNavBar}>
        <img src="/assets/icons/hamburger.svg" alt="" className="icon" />
      </div>
      {filteredNavItems.map((navItem) => {
        const isSelected = navItem.routes.some(
          (route) =>
            location.pathname === route ||
            location.pathname.startsWith(`${route}/`)
        );

        return (
          <Link to={navItem.redirectTo} key={navItem.id}>
            <div
              id={navItem.id}
              className={`nav-item fill-width ${
                isSelected ? "selected-nav" : ""
              }`}
            >
              <img
                src={`/assets/icons/${navItem.img}.svg`}
                alt=""
                className="icon"
              />
              <span className="text-2 font">{navItem.name}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}

function Navigation() {
  return (
    <>
      <HighlightSelected />
    </>
  );
}

export default Navigation;
